import { BarChart3, MessageSquare, DollarSign, Folder, Timer } from 'lucide-react';

/* The reports, in the order the sidebar lists them under Reports.

   They used to be a row of tab buttons along the top of the Reports page,
   beside its filters, and the page got crowded. Now each is a link in the
   sidebar to `/Reports?report=<key>`, so a report can be bookmarked or sent
   to someone, and the page reads which one to show from the address. This
   list is the one both of them read, so the sidebar cannot offer a report the
   page does not know. */
export const REPORTS = [
  { key: 'general', label: 'General Report', icon: BarChart3 },
  { key: 'tenant_updates', label: 'Tenant Updates', icon: MessageSquare },
  { key: 'ti_payment', label: 'TI Payment Report', icon: DollarSign },
  { key: 'capital_updates', label: 'CapEx/MOE Updates', icon: MessageSquare },
  { key: 'capital_files', label: 'CapEx/MOE Files', icon: Folder },
  { key: 'review_turnaround', label: 'Review Turnaround', icon: Timer },
];

export const DEFAULT_REPORT = 'general';

/* The address of one report. The General Report keeps plain `/Reports`, which
   is what every old bookmark and link already says. */
export function reportPath(key) {
  return key === DEFAULT_REPORT ? '/Reports' : `/Reports?report=${key}`;
}

/* The report the address asks for. Anything missing or unrecognised - an old
   link, a typo - is the General Report rather than an empty page. */
export function reportFromSearch(search) {
  const key = new URLSearchParams(search).get('report');
  return REPORTS.find(r => r.key === key) ?? REPORTS[0];
}

/* What the page area is keyed on, so a crashed page clears itself when the
   person goes somewhere else (see the ErrorBoundary in Layout).

   Moving between reports is the one change of address that must not count.
   Keying on it would rebuild the Reports page from scratch, and its filters -
   portfolio, budget year, completed, archived - would all go back to their
   defaults every time someone picked another report from the sidebar. They
   apply to all five reports precisely so they carry from one to the next. */
export function pageKey(location) {
  /* The router matches paths ignoring case, so this does too. */
  if (location.pathname.toLowerCase() === '/reports') return location.pathname;
  return location.pathname + location.search;
}
